import { InjectionToken } from '@angular/core';

/**
 * A PreviewVerifier validates a raw preview-cookie value against the
 * server-side HMAC secret. Implementation lives in
 * src/preview-cookie-server.ts and is wired via app.config.server.ts.
 *
 * Pure interface — no Node imports — so this file compiles cleanly into
 * the client bundle. The interceptor reads this token with
 * `{ optional: true }`; on the browser it resolves to null because
 * app.config.ts does NOT provide it. Only the SSR entry
 * (app.config.server.ts) binds a concrete implementation.
 */
export interface PreviewVerifier {
  verify(cookieValue: string | undefined): boolean;
}

export const PREVIEW_VERIFIER = new InjectionToken<PreviewVerifier>('PREVIEW_VERIFIER');
